import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthContext";
import { userCanAccessOps } from '../../utils/userPermissions';

/**
 * Component that redirects users to their appropriate default page based on role
 */
export const DefaultRedirect: React.FC = () => {
  const { user, isLoading } = useAuth();

  // Wait for user data to load before making redirect decision
  if (isLoading) {
    return null; // Don't redirect yet, let loading continue
  }

  // Redirect internal staff (admin/reviewer) to ops dashboard
  if (userCanAccessOps(user)) {
    return <Navigate to="/ops" replace />;
  }

  // Default redirect for all other users (firm_admin, firm_user)
  return <Navigate to="/jobs" replace />;
};